import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reporteria',
  templateUrl: './reporteria.component.html',
  styleUrls: ['./reporteria.component.scss']
})
export class ReporteriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/reporteria/reporteria.component.ts